module.exports = __webpack_public_path__ + "res/Roboto-ThinItalic-webfontd41d.eot?6be6cc4afd3acbbe3096590d7ed9241d";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-ThinItalic-webfontd41d.eot
// module id = 62
// module chunks = 0